import React, { useEffect, useState, useRef } from "react";
import PropTypes from 'prop-types';
//import { useFormContext } from 'react-hook-form';


import * as Icon from 'react-feather';
import { useTranslation } from "react-i18next";
const ViewUploadfile = ({ register, errors, methods, biodata, onImageChange }) => {
  const { t } = useTranslation();

  // const {  setValue } = methods;
 

  const [preview, setPreview] = useState(biodata ? biodata.imgprofile : null);
  const fileInputRef = useRef(null);



  //const { getValues } = useFormContext();
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    console.log('handleImageChange triggered, file:', file);

    if (file) {
      const fileName = file.name;
      const extension = fileName.split('.').pop().toLowerCase();
      const allowedExtensions = ['jpg', 'jpeg', 'png'];
      const objectUrl = URL.createObjectURL(file);
      const maxSize = 2 * 1024 * 1024; // 2MB
      
      console.log('File details:', { name: fileName, size: file.size, type: file.type });
      
      // Clear any previous errors
      methods.clearErrors('imgprofile');
      
      if (!allowedExtensions.includes(extension)) {
        console.log('Invalid file extension:', extension);
        methods.setError('imgprofile', {
          type: 'manual',
          message: t('Unsupported file extension (only jpg, jpeg, png allowed)'),
        });
        return;
      }
      
      if (file.size > maxSize) {
        console.log('File too large:', file.size);
        methods.setError('imgprofile', {
          type: 'manual',
          message: t('The file is too large (max 2MB)'),
        });
        return;
      }

      // Update preview
      setPreview(objectUrl);
      
      console.log('File is valid, updating form...');
      console.log('Form value before setting:', methods.getValues("imgprofile"));
      
      // Let react-hook-form handle the file naturally - don't use setValue
      // The file should already be set by the register function
      
      console.log('Form value after file selection:', methods.getValues("imgprofile"));
      console.log('Form is dirty:', methods.formState.isDirty);
      
      // Call onImageChange callback if provided
      if (onImageChange) {
        onImageChange(objectUrl);
      }
    } else {
      console.log('No file selected, clearing preview');
      // No file selected, clear everything
      setPreview(null);
      methods.clearErrors('imgprofile');
    }
  };

  // Function to convert base64 to File object (if needed for form submission)
  const base64ToFile = (base64String, filename = 'extracted-image.jpg') => {
    try {
      // Handle data URL format (data:image/jpeg;base64,...)
      const arr = base64String.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      
      // Create a proper file with correct extension
      const extension = mime.split('/')[1] || 'jpg';
      const properFilename = `${filename.split('.')[0]}.${extension}`;
      
      return new File([u8arr], properFilename, { type: mime });
    } catch (error) {
      console.error('Error converting base64 to file:', error);
      return null;
    }
  };

  // Function to set image from base64 (can be called externally)
  const setImageFromBase64 = (base64Data) => {
    if (!fileInputRef.current) {
      console.warn('File input ref not available');
      return;
    }

    try {
      const file = base64ToFile(base64Data, 'extracted-profile-image.jpg');
      if (file) {
        console.log("Setting base64 image in form");
        
        // Create a DataTransfer object to simulate file selection
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        
        // Assign the files to the input element directly
        fileInputRef.current.files = dataTransfer.files;
        
        // Update preview immediately
        setPreview(base64Data);
        
        // Create a FileList-like object and set it directly
        const fileList = fileInputRef.current.files;
        
        // Use setValue with the actual FileList from the input element
        methods.setValue("imgprofile", fileList, { 
          shouldValidate: true, 
          shouldDirty: true,
          shouldTouch: true 
        });
        
        console.log("File injected into input element:", fileInputRef.current.files[0]);
        console.log("FileList object:", fileList);
        console.log("Form value after injection:", methods.getValues("imgprofile"));
        console.log("Form is dirty after injection:", methods.formState.isDirty);
        
        // Clear any existing errors
        methods.clearErrors("imgprofile");
        console.log('Base64 converted to file:', file.name, file.size, 'bytes');
      } else {
        console.warn('Failed to convert base64 to file');
      }
    } catch (error) {
      console.warn('Could not set base64 as file in form:', error);
    }
  };

  // Expose the setImageFromBase64 function
  useEffect(() => {
    if (window) {
      window.setImageFromBase64 = setImageFromBase64;
    }
  }, []);


  useEffect(() => {

  }, [])

  return (
    <>{/** photo */}
      <div className="col-lg-6 " >

        <div className="input-block mb-3">
          <div className="d-flex justify-content-center mt-1">
            <div className="position-relative rounded-circle border border-secondary d-flex justify-content-center align-items-center overflow-hidden bg-light" style={{ width: '150px', height: '150px', cursor: 'pointer' }}

              onClick={() => fileInputRef.current?.click()}
            >
              {preview ? (
                <img
                  src={preview}
                  alt="Profile"
                  className="w-100 h-100"
                  style={{ objectFit: 'cover', objectPosition: 'top' }}
                />
              ) : (
                <Icon.User size={40} />
              )}
            </div>
          </div>
        </div>
   
        <div className="input-block">
          <label htmlFor="imgprofile" className="form-label">{t("Upload Profile Image")}</label>
         <div className="position-relative">
  <input
    type="file"
    id="imgprofile"
    name="imgprofile"
    accept="image/*"
    className="form-control pe-5" // add right padding so text doesn't overlap with icon
    {...register("imgprofile", {
      required: false,
      validate: {
        fileSize: (fileList) => {
          if (!fileList || fileList.length === 0) return true;
          const file = fileList[0];
          return file.size <= 2 * 1024 * 1024 || t('The file is too large (max 2MB)');
        },
        fileType: (fileList) => {
          if (!fileList || fileList.length === 0) return true;
          const file = fileList[0];
          const extension = file.name.split('.').pop().toLowerCase();
          const allowedExtensions = ['jpg', 'jpeg', 'png'];
          return allowedExtensions.includes(extension) || t('Unsupported file extension (only jpg, jpeg, png allowed)');
        }
      },
      onChange: (e) => {
        handleImageChange(e);
      }
    })}
    ref={(e) => {
      // Properly register the ref with react-hook-form
      const { ref } = register("imgprofile");
      ref(e);
      fileInputRef.current = e;
    }}
  />

  {/* Trash icon absolutely positioned inside input */}
  <i
    className="fe fe-trash text-primary"
    style={{
      position: "absolute",
      right: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      cursor: "pointer",
    }}
    onClick={() => {
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
        setPreview(null);
        // Clear form value as well
        if (methods.setValue) {
          methods.setValue("imgprofile", null, { 
            shouldValidate: true, 
            shouldDirty: true,
            shouldTouch: true 
          });
          methods.clearErrors("imgprofile");
        }
        
        console.log('Form cleared, current value:', methods.getValues("imgprofile"));
        // Call onImageChange callback if provided
        if (onImageChange) {
          onImageChange(null);
        }
      }
    }}
    title="Reset Image"
  />
</div>

          <p className="text-danger biodata">{errors.imgprofile?.message}</p>
          
          
        </div>
      </div>


    </>



  );
};

ViewUploadfile.propTypes = {

  methods: PropTypes.shape({
    handleSubmit: PropTypes.func,
    clearErrors: PropTypes.func,
    reset: PropTypes.func,
    register: PropTypes.func,
    watch: PropTypes.func,
    setError: PropTypes.func,
    setValue: PropTypes.func,
    trigger: PropTypes.func,
    getValues: PropTypes.func,
    formState: PropTypes.object,
  }),
  biodata: PropTypes.shape({
    imgprofile: PropTypes.string,
  }),
  base64Image: PropTypes.string, // New prop for base64 image data
  onImageChange: PropTypes.func, // New prop for image change callback
  register: PropTypes.func.isRequired,
  //setValue: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
};
export default ViewUploadfile;
